import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalService, UtilitiesService } from '@core/services';
import { Observable, Subscription } from 'rxjs';
import { select, NgRedux } from '@angular-redux/store';
import { Order, IAppState, Actions } from '@core/redux/stores';
import * as _ from 'lodash-es';
import { TaxCalculatorService } from '@features/ordering/services/tax-calculator.service';
import { FinalCheckoutService } from '@features/checkout/services';

@Component({
  selector: 'app-add-tip',
  templateUrl: './add-tip.component.html',
  styleUrls: ['./add-tip.component.less']
})
export class AddTipComponent implements OnInit, OnDestroy {
  @select((appState) => appState.activeOrder) activeOrder: Observable<Order>;

  amount: number | string;
  public isOthersSelect: boolean;
  selectedTipValue?: number;
  otherAmounts: any;
  private subscriptions = new Subscription();
  private order: Order;
  public standardOptions = [3, 4, 5, 7];
  DEFAULT_TIP_VALUE = 5;
  subTotal: number;
  constructor(private modalService: ModalService, private ngRedux: NgRedux<IAppState>,
         private taxCalulcator: TaxCalculatorService,
         private checkout: FinalCheckoutService,
         private utilities: UtilitiesService
    ) {
    this.subscriptions.add(this.activeOrder.subscribe((data) => {
      if((data.tipAmount !== undefined && data.tipAmount !== null) || (this.selectedTipValue === null || this.selectedTipValue === undefined)) {
        this.selectedTipValue = data.tipAmount;
      }
      this.order = _.cloneDeep(data);

    }));
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit() {
    this.isOthersSelect = false;
    this.otherAmounts = this.utilities.createRange(0, 50, 1);
    if (this.selectedTipValue !== null && this.selectedTipValue !== undefined && this.selectedTipValue !== 0) {
      if (this.standardOptions.includes(this.selectedTipValue)) {
        this.amount = this.selectedTipValue;
      } else {
        this.amount = 'Custom';
        this.isOthersSelect = true;
      }
    } else {
      this.amount = this.DEFAULT_TIP_VALUE;
      this.selectedTipValue = this.DEFAULT_TIP_VALUE;
    }
    this.hideCloseButton();
  }
  private hideCloseButton() {
    const element = <HTMLElement>document.querySelector('#modalHeader');
    if (element) {
      element.style.display = 'none';
    }
  }

  getBtnActiveStyle(amt?: number | string) {
      if (this.amount === amt && !this.isOthersSelect || this.isOthersSelect && !amt) {
        return 'btn btn-wab active';
      } else {
        return 'btn btn-wab';
      }
  }

  toggleOtherValues(value, amt) {
    if (value === 'Custom') {
      this.isOthersSelect = true;
      this.selectedTipValue = this.DEFAULT_TIP_VALUE;
    } else {
      this.isOthersSelect = false;
    }
    const amount = amt ? amt : (amt === 0 ? amt : this.DEFAULT_TIP_VALUE );
    this.amount = amount;
    this.selectedTipValue = amount;
  }

  submitTip() {
    this.order.tipAmount = this.selectedTipValue;
    this.updateOrderAndEvents();
  }

  cancel() {
    this.order.tipAmount = 0;
    this.updateOrderAndEvents();
  }

  private updateOrderAndEvents() {
    this.checkout.isTipSet(true);
    this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.order });
    this.modalService.hideModal();
  }
}
